/* global fbq */
import React from "react";
import lTheanineImg from '../assets/images/l-theanine_what_is.png';
import TipsSLeep from '../assets/images/5_tips_for_good_sleep.png';
import ManSLeep from '../assets/images/man_sleeping.png';

import scienceOfSleepImg from '../assets/images/science_of_sleep.png';
import { Link } from 'react-router-dom';

window.gtag('event', 'User Opened Blog');
fbq('track', "User Opened FAQ page");
// Mock posts data (replace with API fetch later, e.g., from Contentful)
const posts = [
    {
        id: 1,
        title: "The Calming Power Duo: Chamomile and Valerian Root for Deep Sleep",
        excerpt: "Discover herbal rituals and Zenzzz pairing tips to ease into sleep without screens.",
        image: TipsSLeep, // Add your blog images to src/assets/images/
        date: 'November 10, 2025',
        author: 'Dr. Sleepwell',
        slug: 'chamomile-valerian-sleep' // For linking to full post
    },
    {
        id: 2,
        title: "How Magnesium Transforms Your Sleep Cycle",
        excerpt: "Unlock the science behind our magnesium blend and why it's a game-changer for restless nights.",
        image: ManSLeep,
        date: 'November 5, 2025',
        author: 'Zenzzz Team',
        slug: 'magnesium-sleep'
    },
    {
        id: 3,
        title: "Debunking Sleep Myths: What Really Works",
        excerpt: "The Science of Sleep: How Your Brain and Body Work with Zenzzz",
        image: scienceOfSleepImg ,
        date: 'October 28, 2025',
        author: 'Dr. Sleepwell',
        slug: 'science-of-sleep'
    },
    {
        id: 4,
        title: "What is L-Theanine?",
        excerpt: "From counting sheep to our all-natural formula—separate fact from fiction for better Zzz's.",
        image: lTheanineImg,
        date: 'October 28, 2025',
        author: 'Dr. Sleepwell',
        slug: 'l-theanine-sleep'
    },
    // Add more for full grid
];

const Blog = () => {
    return (
        <section id="blog" className="blog-section">
            <div className="container">
                <h2 className="section-title">Sleep Insights from Zenzzz</h2>
                <p className="section-subtitle">Expert tips, science, and stories to help you get your zen on.</p>
                <div className="blog-grid">
                    {posts.map((post) => (
                        <article key={post.id} className="blog-card">
                            <img src={post.image} alt={post.title} className="blog-image" />
                            <div className="blog-content">
                                <div className="blog-meta">
                                    <span className="blog-date">{post.date}</span>
                                    <span className="blog-author">by {post.author}</span>
                                </div>
                                <h3 className="blog-title">{post.title}</h3>
                                <p className="blog-excerpt">{post.excerpt}</p>
                                <Link to={`/blog/${post.slug}`} className="blog-link">
                                    Read More →
                                </Link>
                            </div>
                        </article>
                    ))}
                </div>

            </div>
        </section>
    );
};

export default Blog;